<template>
  <div class="vehicle-last-data">
    <!-- 标题 -->
    <div class="page_header">
      <h3>车辆最后一条数据查询</h3>
    </div>
    <el-divider></el-divider>
    
    <!-- 查询条件 -->
    <div class="query-condition">
      <el-form :inline="true" :model="queryForm" class="demo-form-inline">
        <el-form-item label="车辆选择：">
          <kl-vehicle-select 
            ref="vehicleSelect" 
            :multiple="false"
            @selected="handleVehicleSelected"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryData" :loading="loading">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    
    <!-- 数据表格 -->
    <div class="table-container">
      <table-pagination 
        :data="vehicleData" 
        :page-size="pageSize" 
        :current-page.sync="currentPage" 
        @page-change="handlePageChange"
        border
      >
        <!-- 基础信息 -->
        <el-table-column prop="VehicleNo" label="车牌号" align="center" width="120"></el-table-column>
        <el-table-column prop="GpsTime" label="数据时间" align="center" width="160"></el-table-column>
        
        <!-- GPS数据 -->
        <el-table-column prop="Longitude" label="经度" align="center"></el-table-column>
        <el-table-column prop="Latitude" label="纬度" align="center"></el-table-column>
        <el-table-column prop="Speed" label="速度(km/h)" align="center"></el-table-column>
        <el-table-column prop="Direction" label="方向" align="center"></el-table-column>
        <el-table-column prop="Status" label="状态" align="center"></el-table-column>
        <el-table-column prop="Mileage" label="里程(km)" align="center"></el-table-column>
        
        <!-- 整车数据 -->
        <el-table-column prop="VehicleStatus" label="车辆状态" align="center"></el-table-column>
        <el-table-column prop="ACC" label="ACC" align="center"></el-table-column>
        <el-table-column prop="GearPosition" label="档位" align="center"></el-table-column>
        <el-table-column prop="SOC" label="SOC(%)" align="center"></el-table-column>
        <el-table-column prop="TotalMileage" label="总里程(km)" align="center"></el-table-column>
        
        <!-- 电池数据 -->
        <el-table-column prop="BatteryTotalVoltage" label="电池总电压(V)" align="center"></el-table-column>
        <el-table-column prop="BatteryTotalCurrent" label="电池总电流(A)" align="center"></el-table-column>
        <el-table-column prop="MaxCellVoltage" label="单体最大电压(V)" align="center"></el-table-column>
        <el-table-column prop="MinCellVoltage" label="单体最小电压(V)" align="center"></el-table-column>
        <el-table-column prop="MaxCellTemperature" label="最高温度(℃)" align="center"></el-table-column>
        <el-table-column prop="MinCellTemperature" label="最低温度(℃)" align="center"></el-table-column>
        
        <!-- 电机数据 -->
        <el-table-column prop="DriveMotorStatus" label="电机状态" align="center"></el-table-column>
        <el-table-column prop="MotorSpeed" label="电机转速(r/min)" align="center"></el-table-column>
        <el-table-column prop="DriveMotorTemperature" label="电机温度(℃)" align="center"></el-table-column>
        
        <!-- 空调数据 -->
        <el-table-column prop="ACSwitchStatus" label="空调状态" align="center"></el-table-column>
        <el-table-column prop="SetTemperature" label="设定温度(℃)" align="center"></el-table-column>
        <el-table-column prop="InsideTemperature" label="车内温度(℃)" align="center"></el-table-column>
        <el-table-column prop="OutsideTemperature" label="车外温度(℃)" align="center"></el-table-column>
      </table-pagination>
    </div>
  </div>
</template>

<script>
import KLVehicleSelect from '@/components/KLVehicleSelect/index.vue';
import TablePagination from '@/components/TablePagination.vue';

import { mapState } from 'vuex';

export default {
  name: 'VehicleLastData',
  components: {
    KLVehicleSelect,
    TablePagination
  },
  data() {
    return {
      queryForm: {
        vehicleNo: ''
      },
      loading: false,
      pageSize: 10,
      currentPage: 1,
      // 综合数据
      vehicleData: []
    };
  },
  computed: {
    ...mapState({
      selectedVehicles: (state) => state.app.vehicles.selectedVehicles,
      size: (state) => state.app.size,
    }),
  },
  methods: {
    // 处理车辆选择
    handleVehicleSelected(vehicles) {
      if (vehicles && vehicles.length > 0) {
        this.queryForm.vehicleNo = vehicles[0].nodeValue;
      }
    },
    // 处理分页
    handlePageChange(page) {
      this.currentPage = page;
    },
    // 查询数据 - 使用模拟数据
    async queryData() {
      // if (!this.queryForm.vehicleNo) {
      //   this.$message.error('请选择车辆');
      //   return;
      // }
      
      this.loading = true;
      try {
        // 使用模拟数据而不是调用真实API
        const mockData = this.getMockData();
        this.formatData(mockData);
        
        // 注释掉真实API调用
        /*
        const response = await queryRealTimeVehicleInfo({
          VehicleNo: this.queryForm.vehicleNo
        });
        
        if (response && response.code === 0) {
          const data = response.data;
          this.formatData(data);
        } else {
          this.$message.error('查询失败: ' + (response.message || '未知错误'));
        }
        */
      } catch (error) {
        console.error('查询车辆数据错误:', error);
        this.$message.error('查询失败，请重试');
      } finally {
        this.loading = false;
      }
    },
    // 获取模拟数据
    getMockData() {
      // 生成当前时间字符串
      const now = new Date();
      const dateTimeStr = now.getFullYear() + '-' + 
                         String(now.getMonth() + 1).padStart(2, '0') + '-' + 
                         String(now.getDate()).padStart(2, '0') + ' ' + 
                         String(now.getHours()).padStart(2, '0') + ':' + 
                         String(now.getMinutes()).padStart(2, '0') + ':' + 
                         String(now.getSeconds()).padStart(2, '0');
      
      return {
        // GPS数据
        Longitude: '118.123456',
        Latitude: '24.654321',
        Speed: '45.6',
        Direction: '东',
        Status: '正常',
        AlarmFlag: '无',
        Altitude: '35.5',
        Mileage: '12345.67',
        GpsTime: dateTimeStr,
        
        // 整车数据
        VehicleStatus: '行驶中',
        ACC: 1,
        GearPosition: 'D档',
        ChargeStatus: '未充电',
        ChargeMode: '无',
        SystemFaultLevel: '无',
        SOC: '85',
        InsideTemperature: '25',
        OutsideTemperature: '30',
        BrakeStroke: '10',
        AcceleratorStroke: '45',
        TotalCharge: '2567.8',
        TotalConsumption: '2345.6',
        AverageConsumption: '0.85',
        TotalMileage: '56789.12',
        DrivingSpeed: '45',
        PositiveInsulationResistance: '500000',
        FaultComponentCode: '',
        DCDCStatus: '正常',
        DCTemperature: '45',
        BatteryInletTemperature: '35',
        BatteryOutletTemperature: '38',
        TMSStatus: '工作中',
        HighVoltageEmergencyStopSwitchStatus: '正常',
        ChargingLineConnectionStatus: '断开',
        
        // 电池数据
        BatteryTotalVoltage: '530.5',
        BatteryTotalCurrent: '150.2',
        MaxCellVoltage: '3.85',
        MaxVoltageCellNo: '1-005',
        MinCellVoltage: '3.82',
        MinVoltageCellNo: '3-012',
        MaxCellTemperature: '42',
        MaxTempSerialNo: '2-008',
        MinCellTemperature: '35',
        MinTempSerialNo: '1-015',
        
        // 电机数据
        DriveMotorStatus: '运行中',
        MotorSpeed: '2500',
        DriveMotorTemperature: '65',
        DriveMotorControllerTemperature: '70',
        
        // 空调数据
        ACSwitchStatus: 1,
        SetTemperature: '24',
        AirVolume: '3',
        AirGearPosition: '2',
        
        // 开关量数据
        ABS: 1,
        Brake: 0,
        Reverse: 0,
        Neutral: 0,
        FrontDoor: 0,
        MiddleDoor: 0,
        LeftTurnLight: 0,
        RightTurnLight: 0,
        HighBeam: 0,
        LowBeam: 1,
        FogLight: 0,
        RearDoor: 0,
        Horn: 0,
        Retarder: 0,
        Clutch: 0,
        HandBrake: 0,
        Heater: 0
      };
    },
    // 格式化数据到综合表格
    formatData(data) {
      this.vehicleData = [{
        // 基础信息
        VehicleNo: this.queryForm.vehicleNo,
        GpsTime: data.GpsTime || '',
        
        // GPS数据
        Longitude: data.Longitude || '',
        Latitude: data.Latitude || '',
        Speed: data.Speed || '',
        Direction: data.Direction || '',
        Status: data.Status || '',
        Mileage: data.Mileage || '',
        
        // 整车数据
        VehicleStatus: data.VehicleStatus || '',
        ACC: this.formatSwitchValue(data.ACC),
        GearPosition: data.GearPosition || '',
        SOC: data.SOC || '',
        TotalMileage: data.TotalMileage || '',
        
        // 电池数据
        BatteryTotalVoltage: data.BatteryTotalVoltage || '',
        BatteryTotalCurrent: data.BatteryTotalCurrent || '',
        MaxCellVoltage: data.MaxCellVoltage || '',
        MinCellVoltage: data.MinCellVoltage || '',
        MaxCellTemperature: data.MaxCellTemperature || '',
        MinCellTemperature: data.MinCellTemperature || '',
        
        // 电机数据
        DriveMotorStatus: data.DriveMotorStatus || '',
        MotorSpeed: data.MotorSpeed || '',
        DriveMotorTemperature: data.DriveMotorTemperature || '',
        
        // 空调数据
        ACSwitchStatus: this.formatSwitchValue(data.ACSwitchStatus),
        SetTemperature: data.SetTemperature || '',
        InsideTemperature: data.InsideTemperature || '',
        OutsideTemperature: data.OutsideTemperature || ''
      }];
    },
    // 格式化开关量值
    formatSwitchValue(value) {
      if (value === undefined || value === null || value === '') return '-';
      return value === 1 ? '开' : value === 0 ? '关' : value;
    }
  }
};
</script>

<style lang="scss" scoped>
.vehicle-last-data {
  padding: 20px;
  
  .page_header {
    margin-bottom: 20px;
    h3 {
      margin: 0;
      font-size: 16px;
      color: #303133;
    }
  }
  
  .query-condition {
    margin-bottom: 20px;
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 4px;
  }
  
  .table-container {
    background-color: #fff;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
}
</style>